import { watchForConversationUpdates } from '../../Conversations/middleware/conversation-subscriptions'

import { updateVideoChat } from './videoChat'

export const getConversation = (conversationUid) => (dispatch, getState) => {

  return dispatch({
    type: "getConversation",
    conversationUid
  })

}

export const sendMessage = (conversationUid, messageData) => (dispatch, getState) => {

  return dispatch({
    type: "sendMessage",
    conversationUid,
    messageData
  })

}

export const onAcceptVideoChatRequest = (messageData) => (dispatch, getState) => {

  var {messaginScreen: {id, messages}, user} = getState();

  var {videoChat} = messageData;

  return Promise.resolve(dispatch({
    type: "onAcceptVideoChatRequest",
    videoChat
  }))

    .then((action) => {

      return window.location.hash = "jitsu-camponent"

    })

}

export const watchConversation = (conversationUid, onNotificationReponse) => (dispatch, getState) => {


  return watchForConversationUpdates(conversationUid, dispatch, onNotificationReponse, getState)

}



// WEBPACK FOOTER //
// ./src/Components/MessagingScreen/actions/index.js